import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { AddUserRoleComponent } from './components/add-user-role/add-user-role.component';
import { LinkedPortalUsersIconComponent } from './components/linked-portal-users-icon/linked-portal-users-icon.component';
import { LinkedPortalUsersComponent } from './components/linked-portal-users/linked-portal-users.component';
import { UserAddComponent } from './components/user-add/user-add.component';
import { UserFormComponent } from './components/user-form/user-form.component';
import { UserManageComponent } from './components/user-manage/user-manage.component';
import { UserSelectComponent } from './components/user-select/user-select.component';
import { AddUserAbilityComponent } from './components/add-user-ability/add-user-ability.component';
import { UserSelectDialogComponent } from './components/user-select-dialog/user-select-dialog.component';
import { EmployeesModule } from '../employees/employees.module';
import { UserRolesMatrixComponent } from './components/user-roles-matrix/user-roles-matrix.component';
import { UserAbilitiesMatrixComponent } from './components/user-abilities-matrix/user-abilities-matrix.component';
import { UserRestrictionsMatrixComponent } from './components/user-restrictions-matrix/user-restrictions-matrix.component';
import { AddUserRestrictionComponent } from './components/add-user-restriction/add-user-restriction.component';


const sharedComponents = 
[
  UserManageComponent, 
  AddUserRoleComponent, 
  UserAddComponent, 
  UserFormComponent,
  LinkedPortalUsersComponent,
  LinkedPortalUsersIconComponent,
  UserSelectComponent,
  AddUserAbilityComponent,
  UserSelectDialogComponent
]

@NgModule({
  declarations: [
    sharedComponents,
    UserRolesMatrixComponent,
    UserAbilitiesMatrixComponent,
    UserRestrictionsMatrixComponent,
    AddUserRestrictionComponent,
  ],
  imports: [
    SharedModule,
    EmployeesModule
  ],
  exports: [
    sharedComponents
  ]
})
export class PortalUsersModule { }
